// extracted by mini-css-extract-plugin
export var fadeInItem = "fade-in-item__GtRxR";
export var fadeIn = "fadeIn__G4Tam";